(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-match-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jobsons-mix-match')) {
    class JobsonsMixMatch extends HTMLElement {
      static cartBusy = false;

      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.timers = new Set();
        this.observers = [];
        this.initFrame = requestAnimationFrame(() => this.initialise());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.initFrame);
        this.observers?.forEach((observer) => observer.disconnect());
        this.timers?.forEach(clearTimeout);
      }

      initialise() {
        if (!this.isConnected || !this.controller) return;
        const signal = this.controller.signal;
        this.querySelectorAll('[data-row]').forEach((row) => this.setupRow(row, signal));
        this.querySelectorAll('[data-card]').forEach((card) => this.updateCard(card));
        this.addEventListener('change', (event) => {
          if (!event.target.matches('select[data-variant]')) return;
          const card = event.target.closest('[data-card]');
          card.querySelector('[data-add]')?.classList.remove('is-success');
          this.setStatus(card, '');
          this.updateCard(card);
        }, { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.addToBasket(button);
        }, { signal });
        this.setAttribute('data-ready', '');
      }

      setupRow(row, signal) {
        const track = row.querySelector('[data-track]');
        const previous = row.querySelector('[data-prev]');
        const next = row.querySelector('[data-next]');
        const cards = Array.from(track.querySelectorAll('[data-card]'));
        const rtl = getComputedStyle(track).direction === 'rtl';
        const stride = () => cards.length ? cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 280;
        const update = () => {
          const position = Math.abs(track.scrollLeft);
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const scrollable = maximum > 4 && cards.length > 0;
          row.querySelector('[data-nav]').hidden = !scrollable;
          row.querySelector('[data-row-footer]').hidden = !scrollable;
          previous.disabled = position < 4;
          next.disabled = position >= maximum - 4;
          const first = Math.min(cards.length, Math.floor((position + 2) / stride()) + 1);
          const last = Math.min(cards.length, Math.ceil((position + track.clientWidth - 2) / stride()));
          row.querySelector('[data-range]').textContent = `${first}–${last} of ${cards.length}`;
        };
        const move = (direction) => track.scrollBy({
          left: stride() * direction * (rtl ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollLeft = event.key === 'Home' ? 0 : (track.scrollWidth - track.clientWidth) * (rtl ? -1 : 1);
          }
        }, { signal });

        // Keep touch scrolling native; mouse dragging starts only after a small threshold.
        let drag = null;
        let suppressClickUntil = 0;
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, select, input, label')) return;
          drag = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft, moved: false };
        }, { signal });
        track.addEventListener('pointermove', (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          const distance = event.clientX - drag.x;
          if (!drag.moved && Math.abs(distance) < 6) return;
          if (!drag.moved) {
            drag.moved = true;
            track.classList.add('is-dragging');
            track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          track.scrollLeft = drag.scroll - distance;
        }, { signal });
        const endDrag = (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          if (drag.moved) suppressClickUntil = performance.now() + 200;
          if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
          drag = null;
          track.classList.remove('is-dragging');
        };
        window.addEventListener('pointerup', endDrag, { signal });
        window.addEventListener('pointercancel', endDrag, { signal });
        track.addEventListener('lostpointercapture', endDrag, { signal });
        track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        track.addEventListener('click', (event) => {
          if (performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        if (typeof ResizeObserver !== 'undefined') {
          const observer = new ResizeObserver(update);
          observer.observe(track);
          if (cards[0]) observer.observe(cards[0]);
          this.observers.push(observer);
        } else {
          window.addEventListener('resize', update, { signal });
        }
        update();
      }

      updateCard(card) {
        const input = card.querySelector('[data-variant]');
        const button = card.querySelector('[data-add]');
        if (!input || !button) return;
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        const available = Boolean(input.value) && option?.dataset.available === 'true';
        button.disabled = !available || card.dataset.busy === 'true' || button.classList.contains('is-success');
        if (card.dataset.busy !== 'true' && !button.classList.contains('is-success')) {
          button.textContent = available ? 'Add to basket' : (input.value ? 'Sold out' : 'Choose an option');
        }
        if (!input.value || !option || input.tagName !== 'SELECT') return;
        card.querySelector('[data-price]').textContent = option.dataset.price;
        card.querySelector('[data-price-prefix]').hidden = true;
        card.querySelector('[data-compare]').textContent = option.dataset.compare;
        card.querySelector('[data-compare-wrap]').hidden = option.dataset.sale !== 'true';
        if (option.dataset.url) {
          card.querySelectorAll('[data-product-link]').forEach((link) => { link.href = option.dataset.url; });
        }
        const image = card.querySelector('[data-product-image]');
        if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.imageAlt || card.dataset.productTitle;
        }
      }

      setStatus(card, message, error = false, showBasket = false) {
        const status = card.querySelector('[data-status]');
        status.textContent = message;
        status.classList.toggle('is-error', error);
        card.querySelector('[data-basket-link]').hidden = !showBasket;
      }

      async addToBasket(button) {
        const card = button.closest('[data-card]');
        const input = card.querySelector('[data-variant]');
        if (button.disabled || !input?.value || card.dataset.busy === 'true') return;
        if (JobsonsMixMatch.cartBusy) {
          this.setStatus(card, 'Please wait while your previous item is added.');
          return;
        }
        JobsonsMixMatch.cartBusy = true;
        card.dataset.busy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        if (input.tagName === 'SELECT') input.disabled = true;
        this.setStatus(card, '');

        let requestSent = false;
        let rejected = false;
        try {
          const cart = Array.from(document.querySelectorAll('cart-drawer, cart-notification')).find((element) => typeof element.getSectionsToRender === 'function' && typeof element.renderContents === 'function');
          const definitions = cart ? cart.getSectionsToRender() : [];
          const sectionIds = [...new Set([...definitions.map((section) => section.id), 'cart-icon-bubble'])].slice(0, 5);
          const root = (window.Shopify?.routes?.root || this.dataset.rootUrl || '/').replace(/\/?$/, '/');
          requestSent = true;
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: input.value, quantity: 1, sections: sectionIds, sections_url: window.location.pathname })
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            rejected = true;
            throw new Error(typeof data.description === 'string' ? data.description : (typeof data.message === 'string' ? data.message : 'This item could not be added. Please check its availability.'));
          }

          // The add has succeeded. A drawer-rendering failure must never report it as a failed add.
          button.classList.add('is-success');
          button.textContent = 'Added ✓';
          this.setStatus(card, 'Added to basket.', false, true);
          try {
            const canRender = cart && definitions.length > 0 && definitions.every((section) => typeof data.sections?.[section.id] === 'string');
            if (canRender) {
              cart.setActiveElement?.(button);
              cart.classList.remove('is-empty');
              cart.renderContents(data);
            } else if (typeof data.sections?.['cart-icon-bubble'] === 'string') {
              const bubble = document.getElementById('cart-icon-bubble');
              const parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const content = parsed.querySelector('.shopify-section');
              if (bubble && content) bubble.innerHTML = content.innerHTML;
            }
          } catch (error) {
            console.warn('Mix & Match: item added; basket display could not refresh.', error);
          }
          // One bubbling event also reaches window, without broadcasting duplicate refreshes.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'jobsons-mix-match', cartData: data } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jobsons-mix-match', productVariantId: input.value, cartData: data })).catch(() => {});
            } catch (_) { /* A theme subscriber must not change the successful add state. */ }
          }
          const timer = setTimeout(() => {
            this.timers.delete(timer);
            button.classList.remove('is-success');
            if (card.isConnected) this.updateCard(card);
          }, 1800);
          this.timers.add(timer);
        } catch (error) {
          const message = rejected ? error.message : (requestSent ? 'We couldn’t confirm whether this was added. Please check your basket before trying again.' : 'The basket could not be opened. Please try the product page.');
          this.setStatus(card, message, true, requestSent);
        } finally {
          JobsonsMixMatch.cartBusy = false;
          delete card.dataset.busy;
          button.removeAttribute('aria-busy');
          if (input.tagName === 'SELECT') input.disabled = false;
          this.updateCard(card);
        }
      }
    }
    customElements.define('jobsons-mix-match', JobsonsMixMatch);
  }

  } catch(e) { console.error(e); }
})();
})();
